import { Controller } from "@hotwired/stimulus"

// Controlador para gestionar menús desplegables.
// Cierra automáticamente otros menús al abrir uno nuevo y se cierra al hacer clic fuera.
export default class extends Controller {
  static targets = ["menu"]

  connect() {
    this.closeAllListener = this.closeIfOther.bind(this)
    document.addEventListener("dropdown:close-all", this.closeAllListener)
  }

  disconnect() {
    document.removeEventListener("dropdown:close-all", this.closeAllListener)
    this.close()
  }

  toggle(event) {
    event.stopPropagation()

    if (this.menuTarget.classList.contains("hidden")) {
      this.open()
    } else {
      this.close()
    }
  }

  open() {
    document.dispatchEvent(new CustomEvent("dropdown:close-all", { detail: { sender: this.element } }))

    this.menuTarget.classList.remove("hidden")
    this.element.classList.add("dropdown-open")

    setTimeout(() => {
      this.closeOnClickOutsideListener = this.closeOnClickOutside.bind(this)
      document.addEventListener("pointerdown", this.closeOnClickOutsideListener, true)
      document.addEventListener("click", this.closeOnClickOutsideListener, true)
    }, 0)
  }

  close() {
    if (!this.hasMenuTarget || this.menuTarget.classList.contains("hidden")) {
      return
    }
    this.menuTarget.classList.add("hidden")
    this.element.classList.remove("dropdown-open")
    if (this.closeOnClickOutsideListener) {
      document.removeEventListener("pointerdown", this.closeOnClickOutsideListener, true)
      document.removeEventListener("click", this.closeOnClickOutsideListener, true)
      this.closeOnClickOutsideListener = null
    }
  }

  closeIfOther(event) {
    if (event.detail.sender !== this.element) {
      this.close()
    }
  }

  closeOnClickOutside(event) {
    if (!this.element.contains(event.target)) {
      this.close()
    }
  }

  hide(event) {
    event.preventDefault()
    this.close()
  }
}
